module.exports = __webpack_public_path__ + "media/public/img/big-bus-tours-logo-ed80b79a3f3d4cb2a8520cbed72da56d.svg";